export default __webpack_public_path__ + "static/media/Back.12766ff2.svg";